import React from 'react';
import SectorPage from '../SectorPage/SectorPage';

const Transport = () => {
  const sectorData = {
    title: "Transport",
    subtitle: "Accélérez votre prospection B2B",
    intro: "Les transporteurs B2B doivent rassurer sur la ponctualité, la traçabilité et la flexibilité. S'appuyer sur des outils de tracking, des services sur mesure et des références logistiques permet d'accélérer les cycles de vente.",
    name: "Transport",
    titleContext: "du secteur des transporteurs",
    responseContext: "des transpoerteurs",
    expertContext: "du secteur des transporteurs"
  };

  return <SectorPage sector={sectorData} />;
};

export default Transport; 